import React from "react";
import { LogOut, RefreshCw } from "lucide-react";
import StatusScreen from "../components/StatusScreen";
import { Button } from "../ui/Button";

// Shown to staff whose every assigned club is deactivated; clears itself on reactivation
const ClubInactiveScreen = ({ message, inactiveClubs = [], onCheckAgain, onLogout }) => {
  const clubNames = inactiveClubs.map((club) => club.name).filter(Boolean);

  return (
    <StatusScreen
      badge="Club deactivated"
      title="Your club is deactivated"
      actions={
        <>
          <Button icon={RefreshCw} onClick={onCheckAgain}>Check again</Button>
          <Button variant="secondary" icon={LogOut} onClick={onLogout}>Log out</Button>
        </>
      }
    >
      <p className="m-0">
        {clubNames.length > 0
          ? `${clubNames.join(", ")} ${clubNames.length > 1 ? "have" : "has"} been deactivated. `
          : ""}
        You can't do anything in ChipMonk until an admin reactivates it. This screen clears on its own
        once the club is active again.
      </p>
      {message && <p className="mt-3 mb-0 text-sm">{message}</p>}
    </StatusScreen>
  );
};

export default ClubInactiveScreen;
